import React, { useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export interface DefaultMessageProps {
    message?: string;
    open?: boolean;
    onClose?: () => void;
    type?: AlertColor;
}


export default function DefaultMessage(props: DefaultMessageProps) {

    const [defaultMessage, setDefaultMessage] = React.useState<DefaultMessageProps>(props);

    useEffect(() => {
        if (props.open !== undefined)
            setDefaultMessage(props);
    }, [props]);

    const handleClose = () => {
        if (props.onClose !== undefined) {
            props.onClose();
        }
    };

    return (
        <Snackbar open={defaultMessage.open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
        }}>
            <Alert onClose={handleClose} severity={defaultMessage.type !== undefined ? defaultMessage.type : "success"} sx={{ width: '100%', whiteSpace: 'pre-line' }}>
                {defaultMessage.message}
            </Alert>
        </Snackbar>
    );
}
